const fontWeight = 'normal' as 'normal'; // eslint-disable-line @typescript-eslint/prefer-as-const

export const bodyFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight
};

export const titleFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 700
};

export const subtitleFont = bodyFont;

export const mediumFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 600
};

export const regularFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 400
};

export const labelFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 900
};

export const semiBoldFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 600
};

export const boldFont500 = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '1.0rem',
  lineHeight: '1.375rem',
  letterSpacing: '0.15px'
};

export const largerBoldFont = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontSize: 'larger',
  fontWeight: 600
};
